import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { featherAirplay } from '@ng-icons/feather-icons';
import { heroUsers, heroBars3 } from '@ng-icons/heroicons/outline';
import { octSearch, octBell } from '@ng-icons/octicons';
import {
  bootstrapSuitcaseLg,
  bootstrapCurrencyDollar,
  bootstrapSearch,
  bootstrapPinMap,
} from '@ng-icons/bootstrap-icons';
import { SelectSingleComponent } from 'src/app/shared/component/select-single/select-single.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-header-home',
  imports: [NgIcon, SelectSingleComponent, FormsModule],
  templateUrl: './header-home.component.html',
  styles: ``,
  viewProviders: [
    provideIcons({
      featherAirplay,
      heroUsers,
      octSearch,
      bootstrapSuitcaseLg,
      octBell,
      bootstrapCurrencyDollar,
      bootstrapSearch,
      bootstrapPinMap,
    }),
  ],
})
export class HeaderHomeComponent implements OnInit, OnChanges {
  @Output() filtersChanged = new EventEmitter<any>();
  @Input() typeJobs: QueryHeader[] = [];
  @Input() locations: QueryHeader[] = [];

  textFilter: string = '';
  selectedTypeJob: string | null = null;
  selectedLocation: string | null = null;
  minSalary: number | null = null;
  maxSalary: number | null = null;

  salaryRanges = [
    { value: '900-1200', label: '900 - 1,200', min: 900, max: 1200 },
    { value: '1200-1800', label: '1,200 - 1,800', min: 1200, max: 1800 },
    { value: '1800-2500', label: '1,800 - 2,500', min: 1800, max: 2500 },
    { value: '2500-3500', label: '2,500 - 3,500', min: 2500, max: 3500 },
    { value: 'mas-de-3500', label: 'Más de 3,500', min: 3500, max: 5000 },
  ];

  isLoadingLocation = false;
  selectedSalary = '';

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['typeJobs']) {
    }

    if (changes['locations']) {
    }
  }

  emitFilters() {
    this.filtersChanged.emit({
      textFilter: this.textFilter || '',
      idJobType: this.selectedTypeJob || '',
      idProvince: this.selectedLocation || '',
      minimumSalary: this.minSalary,
      maximumSalary: this.maxSalary,
    });
  }

  onSeleccionado(valor: any, tipo: 'location' | 'jobType' | 'salary') {
    switch (tipo) {
      case 'location':
        this.selectedLocation = valor;
        break;
      case 'jobType':
        this.selectedTypeJob = valor;
        break;
      case 'salary':
        const salaryItem = this.salaryRanges.find(
          (item) => item.value === valor
        );
        if (salaryItem) {
          this.minSalary = salaryItem.min;
          this.maxSalary = salaryItem.max;
        } else {
          this.minSalary = null;
          this.maxSalary = null;
        }
        break;
    }
  }

  buscarEmpleos() {
    this.emitFilters();
  }
}
